import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type OrdersCountFragment = { paid: number, unpaid: number, draft: number, issue: number, unapproved: number, approved: number, completed: number };

export const OrdersCountFragmentDoc = gql`
    fragment OrdersCountFragment on OrdersCountInfoType {
  paid
  unpaid
  draft
  issue
  unapproved
  approved
  completed
}
    `;